<template>
  <div class="direction-icons items-center" :class="ui?.root">
    <NuxtLink
      v-for="dir in preparedDirections"
      :key="dir.id"
      class="flex items-center"
      :class="ui?.link"
      data-slot="link"
      :to="`/directions/${dir.id}`"
    >
      <Icon
        :name="getDirectionIcon(dir)"
        class="direction-icon"
        :class="ui?.icon"
      />
    </NuxtLink>

    <UDropdownMenu
      v-if="directions?.length && directions?.length > 2"
      class="border"
      :items="preparedOtherDirections as DropdownMenuItem[]"
      label-key="name"
    >
      <UButton
        class="direction-icon border-neutral-border-default text-neutral-default max-xl:p-0!"
        :class="ui?.icon"
        variant="outline"
        color="white"
        icon="i-local-ellipsis"
        :ui="{
          leadingIcon: 'max-xl:w-2.75',
        }"
      />
    </UDropdownMenu>
  </div>
</template>

<script lang="ts" setup>
import type { DropdownMenuItem } from '@nuxt/ui'
import type { DirectionRef } from '~/api'
import { getDirectionIcon } from '~/shared'

defineOptions({
  name: 'DirectionIcons',
})

const props = defineProps<{
  directions: DirectionRef[] | null
  ui?: {
    root?: string
    link?: string
    icon?: string
  }
}>()

const preparedDirections = computed(() =>
  props.directions?.filter((_, index) => index < 2),
)

const preparedOtherDirections = computed(() =>
  props.directions
    ?.filter((_, index) => index > 1)
    .map((dir) => ({
      ...dir,
      to: `/directions/${dir.id}`,
    })),
)
</script>

<style lang="scss" scoped>
.direction-icons {
  display: flex;
  gap: 8px;

  @include isLessThan(xl) {
    gap: 6px;
  }
}

.direction-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;

  @include isLessThan(xl) {
    width: 16px;
    height: 16px;
    border-radius: 6px;
  }

  @include isLessThan(xl) {
    width: 24px;
    height: 24px;
  }
}
</style>
